import axios from '@/axios';

export async function getDoctors() {
    try {
        const { data } = await axios.get("/professional_doctors/list");
        return data.data ? data.data : data;
    } catch (error) {
        return { error };
    }
}

export async function getSpecialties() {
    try {
        const { data } = await axios.get("/specialties");
        return data.data ? data.data : data;
    } catch (error) {
        return { error };
    }
}

export async function saveDoctor(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/professional_doctors/${id}` : `/professional_doctors`;
    return await axios({ method, url, data: data });
}
